module.exports = __webpack_public_path__ + "media/Video 10.9d4f5d7d.mp4";